import moment from 'moment'
import { createSlice } from '@reduxjs/toolkit'

export const eventSlice = createSlice({
  name: 'event',
  initialState: {
    title: 'Teknikforce Seminar',
    summary :'Teknikforce exclusive product seminar',
    files: [],
    startDate: moment().format('YYYY-MM-DD'),
    startTime: '09:00 AM',
    endDate: moment().format('YYYY-MM-DD'),
    endTime: '05:00 PM',
    timezone: ' Africa/Abidjan',
    allDayCheck: false,
    isHideAddress: true,
    isHideServices: true,
    services: [
      { name: 'Wi-fi', val: 'wifi', checked: true },
      { name: 'Bathroom', val: 'toilet-portable', checked: false },
      { name: 'Handicapped facilities', val: 'wheelchair', checked: true },
      { name: 'Babies allowed', val: 'child', checked: false },
      { name: 'Pets allowed', val: 'paw', checked: false },
      { name: 'Parking', val: 'parking', checked: true },
      { name: 'Food', val: 'utensils', checked: true }
    ],
    
    about: 'Come and join us in celebrating our exclusive product seminar with Teknikforce.',
    contactName: 'Cyril M Gupta',
    phone: '+00-35353673456',
    contactEmail: 'support@teknikforce.com',
    website: 'http://teknikforce.com/support',
    titleFont: 'Arial',
    cardColor: '#ffffff',
    titleColor: '#000000',
    summaryColor: '#000000',
    sectionTitleColor: '#000000',
    dateTextColor: '#473bf5',
    dateBorderColor: '#4e7be4',
    serviceIconColor: '#000000',
    aboutTextColor: '#000000',
    contactHeadingColor: '#000000',
    contactDataColor: '#473bf5',
    buttonBackgroundColor: '#1e2746',
    buttonTextColor: '#ffffff',
    locationTextColor: '#ffffff',
    locationIconColor: '#000000',
    locationBgColor: '#5d59ff',
    contactDivBgColor : '#eaedff',
    dateBgColor:'#eaedff'
    
  },
  reducers: {
    setEventField(state, action) {
      state[action.payload.key] = action.payload.val
    },
    setImage(state, action) {
      state.files[0] = action.payload
    },
    setAllDayCheck(state, action) {
      state.allDayCheck = action.payload
    },
    toggleHideAddress(state) {
      state.isHideAddress = !state.isHideAddress
    },
    toggleHideServices(state){
      state.isHideServices = !state.isHideServices
    },
    setService(state, action) {
      state.services[action.payload.id].checked = action.payload.checked
    },
    initializeEvent(state, action) {
      state.title = 'Teknikforce Seminar'
      state.summary = 'Teknikforce exclusive product seminar'
      state.files = []
      state.startDate = moment().format('YYYY-MM-DD')
      state.startTime = '09:00 AM'
      state.endDate = moment().format('YYYY-MM-DD')
      state.endTime = '05:00 PM'
      state.timezone = '+04:00'
      state.allDayCheck = false
      state.isHideAddress= true;
      state.isHideServices = true;
      state.services = [
        { name: 'Wi-fi', val: 'wifi', checked: true },
        { name: 'Bathroom', val: 'toilet-portable', checked: false },
        { name: 'Handicapped facilities', val: 'wheelchair', checked: true },
        { name: 'Babies allowed', val: 'child', checked: true },
        { name: 'Pets allowed', val: 'paw', checked: true },
        { name: 'Parking', val: 'parking', checked: true },
        { name: 'Food', val: 'utensils', checked: true }
      ]
      state.about = 'Come and join us in celebrating our exclusive product seminar with Teknikforce.'
      state.contactName = 'Cyril M Gupta'
      state.phone = '+00-35353673456'
      state.contactEmail = 'support@teknikforce.com'
      state.website = 'https://teknikforce.com/'
      state.titleFont = 'Arial'
      state.cardColor = '#ffffff'
      state.titleColor = '#000000'
      state.summaryColor = '#000000'
      state.sectionTitleColor = '#000000'
      state.dateTextColor = '#473bf5'
      state.dateBorderColor = '#4e7be4'
      state.serviceIconColor = '#000000'
      state.aboutTextColor = '#000000'
      state.contactHeadingColor = '#000000'
      state.contactDataColor = '#473bf5'
      state.buttonBackgroundColor = '#1e2746'
      state.buttonTextColor = '#ffffff'
      state.locationTextColor = '#ffffff'
      state.locationIconColor = '#000000'
      state.locationBgColor = '#5d59ff'
      state.contactDivBgColor = '#eaedff'
      state.dateBgColor='#eaedff'
    }
  }
})

export const {
  setEventField,
  setImage,
  setAllDayCheck,
  setService,
  initializeEvent,
  toggleHideAddress,
  toggleHideServices,
} = eventSlice.actions
export default eventSlice.reducer